import { Panels } from "@msuite/ui/panels";
import { useIncomingInvoice } from "@/hooks/use-incoming-invoice";
import type { IncomingInvoicePanelBaseProps } from "../../shared";
import { IncomingInvoiceDeliveryNotesCard } from "./incoming-invoice-delivery-notes-card";
import { IncomingInvoiceDocument } from "./incoming-invoice-document";
import { IncomingInvoiceRemindersCard } from "./incoming-invoice-reminders-card";
import { IncomingInvoiceSourceCard } from "./incoming-invoice-source-card";
import { IncomingInvoiceTimeline } from "./incoming-invoice-timeline";

/** Where the invoice came from and its document on the left, everything that happened on the right. */
export function IncomingInvoiceDetailsTab({ incomingInvoiceId }: IncomingInvoicePanelBaseProps) {
	/** Query */
	const { incomingInvoice, isLoading, refetch } = useIncomingInvoice(incomingInvoiceId);

	/** Render */
	return (
		<Panels>
			<Panels.Panel
				flex={1}
				className="bottom-space"
			>
				<IncomingInvoiceSourceCard incomingInvoice={incomingInvoice} />
				<IncomingInvoiceRemindersCard incomingInvoice={incomingInvoice} />
				<IncomingInvoiceDeliveryNotesCard incomingInvoice={incomingInvoice} />
				<IncomingInvoiceDocument incomingInvoice={incomingInvoice} />
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<IncomingInvoiceTimeline
					events={incomingInvoice?.events ?? []}
					isLoading={isLoading}
					refetch={async () => {
						await refetch();
					}}
				/>
			</Panels.Panel>
		</Panels>
	);
}
